import {useCallback, useEffect, useState} from 'react';

import {faXmark} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {AxiosResponse} from 'axios';
import Button from 'components/Button/Button';
import Checkbox from 'components/Checkbox/Checkbox';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import useOnClickOutside from 'hooks/useOnClickOutside';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {getBeerStylesData} from 'services/beer-styles';
import {setShowFilterAC} from 'store/filter/filterSlice';
import {setCheckedBeerStyleAC} from 'store/singleBrewery/singleBrewerySlice';
import ApiData from 'typescript/interfaces/ApiData';
import BeerStyle from 'typescript/models/BeerStyle';
import './Filter.scss';

interface IFilterProps {
  onFilter: (payload: string[]) => void;
  onClear: () => void;
}

const Filter = ({onFilter, onClear}: IFilterProps) => {
  const dispatch = useSetGlobalState();

  const [beerStyles, setBeerStyles] = useState<BeerStyle[]>([]);
  const {show} = useGlobalState((state) => state.filter);
  const {
    beersList: {checkedBeerStyles},
  } = useGlobalState((state) => state.singleBrewery);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    dispatch(setShowFilterAC(false));
  });

  const setData = useCallback(async () => {
    const search = {page: 1, per_page: 50, order: 'desc', name: ''};

    const response: AxiosResponse<ApiData<BeerStyle[]>> = await getBeerStylesData(search);
    setBeerStyles(response.data.data);
  }, []);

  useEffect(() => {
    setData();
  }, [setData]);

  const handleCheck = (beerStyleId: string) => {
    let payload = [...checkedBeerStyles, beerStyleId];
    if (checkedBeerStyles.includes(beerStyleId)) {
      payload = checkedBeerStyles.filter((checkedBeerStyleId) => checkedBeerStyleId !== beerStyleId);
    }

    dispatch(setCheckedBeerStyleAC(payload));

    onFilter(payload);
  };

  return (
    <div ref={containerRef}>
      {show && (
        <div className="filter" data-testid="style-filter">
          <Button variant="default" onClick={onClear} title="Clear all beer styles from filter">
            Clear All
            <FontAwesomeIcon icon={faXmark} />
          </Button>
          <div className="filter__items">
            {beerStyles.map((style) => {
              return (
                <div
                  key={style.id}
                  className={`filter__item ${checkedBeerStyles.includes(style.id) ? 'filter__item--checked' : ''}`}
                >
                  <Checkbox
                    type="secondary"
                    checked={checkedBeerStyles.includes(style.id)}
                    onChange={() => handleCheck(style.id)}
                  />
                  <Text tag="p">{style.attributes.name}</Text>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Filter;
